export default __webpack_public_path__ + "static/media/image-ph-health-briefing-m@3x.16879c2b.png";